export default __webpack_public_path__ + "static/media/session-icon.0de2aa3a.svg";